export default {
  computed: {
    sliderStyle () {
      return {
        backgroundColor: this.$vuetify.theme.primary
      }
    },
    tooltipStyle () {
      return {
        backgroundColor: this.$vuetify.theme.primary,
        borderColor: this.$vuetify.theme.primary
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/TooltipStyle.js